import React, {Component} from "react";
import Label from "../Label/Label";
import T from "../t/T";
import "./RadioButton.scss";

class RadioButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: this.props.checked || false
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.checked !== this.props.checked) {
      this.setState({
        checked: this.props.checked
      });
    }
  }

  render() {
    const { label = null, inputName = "", text = "", value, handleChange, tabIndex} = this.props;

    return <div className="radio__input">
      { label && <Label labelText={label} />}
      <input type="radio" name={inputName} value={value} onChange={handleChange} checked={this.state.checked} tabIndex={tabIndex}/> <T token={text} />
    </div>;
  }
}

export default RadioButton;
